/**
 * @license
 * Copyright 2022 Superflows.dev
 * SPDX-License-Identifier: MIT
 */

import {SfMultiselectSearch} from '../sf-multiselect-search.js';
// import { stub } from 'sinon';
// import {fixture, assert} from '@open-wc/testing';
import {assert} from '@open-wc/testing';
// import {html} from 'lit/static-html.js';

//const TIMEOUT = 2000;
suite('sf-multiselect-search > left menu', () => {

  test('is defined', () => {
    const el = document.createElement('sf-multiselect-search');
    assert.instanceOf(el, SfMultiselectSearch);
  });


});

